// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"51b95b4d","703":"5a9583ab"}[chunkId] + ".chunk.js";
};